/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planlargecustomers2Inputs */

const en_planlargecustomers2 = /** @type {(inputs: Planlargecustomers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Large customers (stadiums, theatres, festivals):`)
};

const de_planlargecustomers2 = /** @type {(inputs: Planlargecustomers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Großkunden (Stadien, Theater, Festivals):`)
};

/**
* | output |
* | --- |
* | "Large customers (stadiums, theatres, festivals):" |
*
* @param {Planlargecustomers2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const planlargecustomers2 = /** @type {((inputs?: Planlargecustomers2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planlargecustomers2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_planlargecustomers2(inputs)
	return de_planlargecustomers2(inputs)
});
export { planlargecustomers2 as "planLargeCustomers" }